import React from 'react';
import { AppContext, defaultState, IAppContext } from './AppContext';

interface AppContextProviderProps {
    children?: any;
}

const AppContextProvider: React.FunctionComponent<AppContextProviderProps> = ({ children }: AppContextProviderProps) => {

    const [appData, setAppData] = React.useState<IAppContext>({ ...defaultState });

    const handleChangeData = (data: any) => {
        setAppData({ ...appData, ...data });
    }

    React.useEffect(() => {
    }, [appData]);

    return (
        <AppContext.Provider value={{ ...appData, changeData: handleChangeData }}>
            {children}
        </AppContext.Provider>
    );
}

export default AppContextProvider;